import styled from '@emotion/styled'

import { WithTheme } from '../../../setup/index'

const DownloadBadgeStyled = styled.a<WithTheme>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.orange};
  color: ${({ theme }) => theme.colors.orange};

  &:hover {
    background-color: ${({ theme }) => theme.colors.green};
    color: ${({ theme }) => theme.colors.orange};
  }
`

const DownloadBadgeIconStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  svg {
    width: 0.625rem;
    font-size: 0.625rem;
    height: 1em;
  }
`

export { DownloadBadgeStyled, DownloadBadgeIconStyled }
